import { styled, useTheme } from '@vebox/etui-system';
import '../utilities/responsive.js';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useEffect, createElement } from 'react';
import '../utilities/get-styleprop.js';
import '../useDebounce/useDebounce.js';
import '../useWindowSize/useWindowSize.js';
import useResponsive from '../useResponsive/useResponsive.js';
import { _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import 'react-dom';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import '../SideDrawer/utils.js';
import '../SideDrawer/SideDrawer.js';
import SidePushPanelDrawer from './SidePushPanelDrawer.js';

const SidePushPanelRoot = styled(Div)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const _excluded = ["isOpen", "panelWidth", "rootFrameId", "drawerType", "children", "styles"];
const SidePushPanelComponent = _ref => {
  let {
      isOpen,
      panelWidth,
      rootFrameId,
      drawerType = 'overlay',
      children,
      styles = {}
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  const {
    screenIsAtMost
  } = useResponsive({
    sm: parseInt(theme.breakpoints[1], 10)
  });
  const isSmView = screenIsAtMost('sm', ['portrait', 'landscape']);
  useEffect(() => {
    const targetDiv = document.querySelector(`#${rootFrameId}`);
    if (drawerType === 'inline' && rootFrameId && !isSmView) {
      targetDiv.style.transition = 'margin-right 0.3s ease-in-out';
      targetDiv.style.marginRight = isOpen ? panelWidth : '0px';
    }
    return () => {
      if (targetDiv) {
        targetDiv.style.marginRight = '0px';
      }
    };
  }, [isOpen]);
  return /*#__PURE__*/createElement(SidePushPanelRoot, styles.root, /*#__PURE__*/createElement(SidePushPanelDrawer, _extends({
    panelWidth: panelWidth,
    isOpen: isOpen
  }, rest, {
    styles: styles.drawer
  }), children));
};
const SidePushPanel = Object.assign(SidePushPanelComponent);

export default SidePushPanel;
